import { render, staticRenderFns } from "./BlockedPackageList.vue?vue&type=template&id=f507f612&"
import script from "./BlockedPackageList.vue?vue&type=script&lang=js&"
export * from "./BlockedPackageList.vue?vue&type=script&lang=js&"
import style0 from "./BlockedPackageList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports